import UseModalPosY from './UseModalPosY'

export default UseModalPosY
